import React, { useState } from 'react';
import { Play, Square, Trophy, RotateCcw } from 'lucide-react';
import '../styles/Controls.css';

const Controls = ({ isPlaying, onStart, onStop, onWinner, onReset, hasStarted, players }) => {
  const [showWinnerSelect, setShowWinnerSelect] = useState(false);
  const [selectedWinners, setSelectedWinners] = useState([]);
  const [isEmpate, setIsEmpate] = useState(false);
  return (
    <div className="controls-container">
      <div className="controls-group">
        {!hasStarted && !isPlaying ? (
          // Solo mostrar Iniciar al principio
          <button 
            className="btn btn-start"
            onClick={onStart}
            title="Iniciar juego"
          >
            <Play size={18} /> Iniciar
          </button>
        ) : (
          // Cuando ya empezó, mostrar Detener y Buenas
          <>
            {!isPlaying ? (
              <button 
                className="btn btn-start"
                onClick={onStart}
                title="Continuar juego"
              >
                <Play size={18} /> Continuar
              </button>
            ) : (
              <button 
                className="btn btn-stop"
                onClick={onStop}
                title="Detener juego"
              >
                <Square size={18} /> Detener
              </button>
            )}
            
            <button 
              className="btn btn-winner"
              onClick={() => {
                if (!showWinnerSelect) {
                  onStop(); // Detener el juego INMEDIATAMENTE
                } else {
                  // Si se está cerrando, resetear selección
                  setSelectedWinners([]);
                  setIsEmpate(false);
                }
                setShowWinnerSelect(!showWinnerSelect);
              }}
              disabled={!isPlaying && !showWinnerSelect}
              title="Declarar ganador"
            >
              <Trophy size={18} /> Buenas
            </button>
            
            {showWinnerSelect && (
              <div className="winner-select" style={{
                position: 'absolute',
                background: 'rgba(15, 15, 35, 0.95)',
                borderRadius: '12px',
                padding: '12px',
                border: '2px solid #10b981',
                zIndex: 1000,
                minWidth: '220px',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)'
              }}>
                <p style={{ color: '#10b981', fontSize: '0.85rem', fontWeight: '600', marginBottom: '8px', textAlign: 'center' }}>
                  {selectedWinners.length === 0 ? '¿Quién ganó?' : `Seleccionados: ${selectedWinners.length}`}
                </p>
                
                {/* Checkbox de empate */}
                <div style={{
                  background: 'rgba(255, 193, 7, 0.1)',
                  border: '1px solid rgba(255, 193, 7, 0.3)',
                  borderRadius: '8px',
                  padding: '8px',
                  marginBottom: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <input
                    type="checkbox"
                    id="empate-checkbox"
                    checked={isEmpate}
                    onChange={(e) => setIsEmpate(e.target.checked)}
                    style={{ cursor: 'pointer' }}
                  />
                  <label htmlFor="empate-checkbox" style={{ 
                    color: '#ffc107', 
                    fontSize: '0.8rem', 
                    cursor: 'pointer',
                    userSelect: 'none'
                  }}>
                    🤝 Empate (+0.5 pts)
                  </label>
                </div>

                {/* Lista de jugadores */}
                {players.map(player => {
                  const isSelected = selectedWinners.includes(player);
                  return (
                    <button
                      key={player}
                      onClick={() => {
                        if (isSelected) {
                          setSelectedWinners(selectedWinners.filter(w => w !== player));
                        } else {
                          setSelectedWinners([...selectedWinners, player]);
                        }
                      }}
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        marginBottom: '6px',
                        background: isSelected 
                          ? 'rgba(16, 185, 129, 0.3)' 
                          : 'rgba(16, 185, 129, 0.1)',
                        border: isSelected
                          ? '2px solid #10b981'
                          : '1px solid rgba(16, 185, 129, 0.3)',
                        borderRadius: '8px',
                        color: '#fff',
                        cursor: 'pointer',
                        fontSize: '0.85rem',
                        transition: 'all 0.2s',
                        fontWeight: isSelected ? '600' : '400'
                      }}
                      onMouseEnter={(e) => {
                        if (!isSelected) e.target.style.background = 'rgba(16, 185, 129, 0.2)';
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected) e.target.style.background = 'rgba(16, 185, 129, 0.1)';
                      }}
                    >
                      {isSelected ? '✅' : '🎉'} {player}
                    </button>
                  );
                })}

                {/* Botón Confirmar */}
                {selectedWinners.length > 0 && (
                  <button
                    onClick={() => {
                      onWinner(selectedWinners, isEmpate);
                      setShowWinnerSelect(false);
                      setSelectedWinners([]);
                      setIsEmpate(false);
                    }}
                    style={{
                      width: '100%',
                      padding: '10px',
                      marginTop: '8px',
                      background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                      border: 'none',
                      borderRadius: '8px',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: '0.85rem',
                      fontWeight: '700',
                      boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)'
                    }}
                  >
                    ✅ Confirmar {isEmpate ? 'Empate' : 'Victoria'}
                  </button>
                )}

                <button
                  onClick={() => {
                    setShowWinnerSelect(false);
                    setSelectedWinners([]);
                    setIsEmpate(false);
                  }}
                  style={{
                    width: '100%',
                    padding: '6px',
                    marginTop: '4px',
                    background: 'rgba(239, 68, 68, 0.1)',
                    border: '1px solid rgba(239, 68, 68, 0.3)',
                    borderRadius: '6px',
                    color: '#fca5a5',
                    cursor: 'pointer',
                    fontSize: '0.75rem'
                  }}
                >
                  Cancelar
                </button>
              </div>
            )}
          </>
        )}

        {!isPlaying && (
          <button 
            className="btn btn-reset"
            onClick={onReset}
            title="Reiniciar juego"
          >
            <RotateCcw size={18} /> Reiniciar
          </button>
        )}
      </div>
    </div>
  );
};

export default Controls;
